export enum TimezoneEnum {
    DK = 'Europe/Copenhagen',
    UK = 'Europe/London'
}

export type Timezone = `${TimezoneEnum}`
